<template>
    <div class="addRealityBox">
        <div class="formBox">
            <ul>
                <li>
                    <header>应用面信息</header>
                    <el-form ref="form1" :model="formData" label-width="180px">
                        <el-form-item :label="item.attrName" v-for="item in formItemData[headerType].yingyongmianxinxi" :key="item.attrIndex">
                            <template v-if="item.valType == 'select'">
                                <RealityQuerySelect v-if="item.attrIndex == 'carrierType'" :formValue="formData[item.attrIndex + 'Str']" :editLook="editLook" :text="item.dictionary" :attrIndex="item.attrIndex" @changeFormData="changeFormData"/>
                                <RealityQuerySelect v-else :formValue="formData[item.attrIndex]" :editLook="editLook" :text="item.dictionary" :attrIndex="item.attrIndex" @changeFormData="changeFormData"/>
                            </template>
                            <template v-else>
                                <el-input :disabled="editLook == 2?true:false" v-model="formData[item.attrIndex]" :type="item.type=='String'?'string':'number'"></el-input>
                            </template>
                        </el-form-item>
                    </el-form>
                </li>
                <li>
                    <header>照明指标</header>
                    <el-form ref="form2" :model="formData" label-width="180px">
                        <el-form-item :label="item.attrName" v-for="item in formItemData[headerType].zhaomingmubiao" :key="item.attrIndex">
                            <template v-if="item.valType == 'select'">
                                <RealityQuerySelect :formValue="formData[item.attrIndex]" :editLook="editLook" :text="item.dictionary" :attrIndex="item.attrIndex" @changeFormData="changeFormData"/>
                            </template>
                            <template v-else>
                                <el-input :disabled="editLook == 2?true:false" v-model="formData[item.attrIndex]" :type="item.type=='String'?'string':'number'"></el-input>
                            </template>
                        </el-form-item>
                    </el-form>
                </li>
                <li>
                    <header>设备信息</header>
                    <el-form ref="form3" :model="formData" label-width="180px" >
                        <el-form-item :label="item.attrName" v-for="item in formItemData[headerType].shebeixinxi" :key="item.attrIndex" :class="item.attrIndex == 'reasonDescription'?'checkoutBox':''">
                            <template v-if="item.valType == 'select'">
                                <RealityQuerySelect v-if="item.attrIndex == 'lampType'" :formValue="formData[item.attrIndex + 'Str']" :contestType="formData['contestType']"  :editLook="editLook" :text="item.dictionary" :attrIndex="item.attrIndex" @changeFormData="changeFormData"/>
                                <RealityQuerySelect :editLook="editLook" :text="item.dictionary" :attrIndex="item.attrIndex" @changeFormData="changeFormData" :formValue="formData[item.attrIndex]"/>
                            </template>
                            <template v-else-if="item.attrIndex == 'reasonDescription' && reasonFlag">
                                <el-checkbox-group :disabled="editLook == 2?true:false" v-model="formData[item.attrIndex]" @change="checkboxChange">
                                    <el-checkbox v-for="subItem in reasonDescriptionArr" :label="subItem.dictCont" :value="subItem.dictCont" name="type" :key="subItem.id"></el-checkbox>
                                    <el-input :class="otherFlag?'opacity1':'opacity0'" v-model="formData.other" :type="item.type=='String'?'string':'number'"></el-input>
                                </el-checkbox-group>
                            </template>
                            <!-- 灯具品牌 -->
                            <template v-else-if="item.attrIndex == 'lampBand'">
                                 <el-select  v-model="formData.lampBand"
                                 :disabled="editLook == 2?true:false"
                                    filterable
                                    allow-create
                                    default-first-option>
                                    <el-option v-for="item in lampBandArr" :key="item.id" :label="item.brandName" :value="item.brandName"></el-option>
                                </el-select>
                            </template>
                            <!-- 灯参编号 -->
                            <template v-else-if="item.attrIndex == 'lampparamId'">
                               <template v-if="editLook != 0">
                                    <span  v-for="(subItem,index) in formData.lampparamNoStr.split(',')" :key="subItem" @click.stop="lookDetailInfo(formData.lampparamId,index)" class="dengcanbianhao">
                                        <span>{{subItem}}</span></span>
                                </template>
                                 <el-select v-else multiple :disabled="editLook == 2?true:false" v-model="formData[item.attrIndex]" class="dengcanbianhaoBox">
                                    <el-option v-for="item in lampparamIdArr" :key="item.lampparamNo" :label="item.lampparamNo" :value="item.id"></el-option>
                                </el-select>
                            </template>
                            <template v-else>
                                <el-input :disabled="editLook == 2?true:false" v-model="formData[item.attrIndex]" :type="item.type=='String'?'string':'number'"></el-input>
                            </template>
                        </el-form-item>
                    </el-form>
                </li>
            </ul>
        </div>
        <!-- 下方上传 -->
        <div class="bottomUpload">
            <!-- 投影点位图 -->
            <UploadImg title="点位图"
            :editLook="editLook"
            name="projectionPointBitmap" 
            :formValue="formData.projectionPointBitmap" 
            @changeImgData="changeImgData"/>
            <UploadImg title="实测数据伪色图" 
            :editLook="editLook"
            name="picMeasuredColor" 
            :formValue="formData.picMeasuredColor"
            @changeImgData="changeImgData"/>
            <UpLoadVideo 
            :formValue="formData.videoLandingEffect"
            :editLook="editLook"
            @changeVideoData="changeVideoData"/>
            <UploadImg title="落地效果照片" 
            :editLook="editLook"
            name="photoLandingEffect" 
            :formValue="formData.photoLandingEffect"
            @changeImgData="changeImgData"/>
        </div>
        <RealityQueryDetailPdf ref="realityQueryDetailPdf"/>
    </div>
</template>
<script>
import { reduce } from 'lodash';
import RealityQuerySelect from '@/views/component/realityQuerySelect.vue'
import UploadImg from '@/views/component/uploadImg.vue'
import UpLoadVideo from '@/views/component/uploadVideo.vue'
import RealityQueryDetailPdf from './realityQueryDetailPdf.vue';
export default {
    props:{
        headerType:{
            default:1
        },
        itemId:{
            default:0
        },
        editLook:{
            default:0
        },
        formData:{
            default:{}
        }
    },
  data() {
    return {
        dialogImageUrl: '',
        dialogVisible: false,
        disabled: false,
        uploadUrl:'',
        // 渲染的数据
        formItemData:{
            1:{
                // 应用面信息
                yingyongmianxinxi:[
                {
                    attrIndex:"carrierType",
                    attrName:"载体类型",
                    valType:'select',
                    dictionary:'zaitileixing',
                    type:'String'
                },{
                    attrIndex:"reflectivity",
                    attrName:"反射率",
                    valType:'input',
                    dictionary:'',
                    type:'Double'
                },{
                    attrIndex:"lightEnvironment",
                    attrName:"光环境亮暗",
                    valType:'select',
                    dictionary:'guanghuanjingliangan',
                    type:'String'
                },{
                    attrIndex:"illuminationH",
                    attrName:"被照面高度(m)",
                    valType:'input',
                    dictionary:'',
                    type:'Double'
                },{
                    attrIndex:"illuminationW",
                    attrName:"被照面宽度(m)",
                    valType:'input',
                    dictionary:'',
                    type:'Double'
                },{
                    attrIndex:"projectionDistance",
                    attrName:"投射距离(m)",
                    valType:'input',
                    dictionary:'',
                    type:'Double'
                }],
                // 照明目标
                zhaomingmubiao:[
                    {
                        attrIndex:"designBrightness",
                        attrName:"设计亮度(cd/m²)",
                        valType:'input',
                        dictionary:'',
                        type:'Double'
                    },{
                        attrIndex:"designIllumination",
                        attrName:"设计照度(lx)",
                        valType:'input',
                        dictionary:'',
                        type:'Double'
                    },{
                        attrIndex:"measuredBrightness",
                        attrName:"实测亮度(cd/m²)",
                        valType:'input',
                    dictionary:'',
                    type:'Double'
                    },{
                        attrIndex:"measuredIlluminance",
                        attrName:"实测照度(lx)",
                        valType:'input',
                    dictionary:'',
                    type:'Double'
                    },{
                        attrIndex:"measuredUniformity",
                        attrName:"实测均匀度",
                        valType:'input',
                    dictionary:'',
                    type:'Double'
                    }
                ],
                // 设备信息
                shebeixinxi:[
                    {
                        attrIndex:"lampparamId",
                        attrName:"灯参编号",
                        valType:'input',
                    dictionary:'',
                    type:'String'
                    },{
                        attrIndex:"luminousFlux",
                        attrName:"光通量(lm)",
                        valType:'input',
                    dictionary:'',
                    type:'Double'
                    },{
                        attrIndex:"lampType",
                        attrName:"灯具类型",
                        valType:'select',
                    dictionary:'dengjuleixing',
                    type:'String'
                    },{
                        attrIndex:"lampBand",
                        attrName:"灯具品牌",
                        valType:'input',
                        dictionary:'',
                        type:'String'
                    },{
                        attrIndex:"lampMode",
                        attrName:"灯具型号",
                        valType:'input',
                    dictionary:'',
                    type:'String'
                    },{
                        attrIndex:"lampPower",
                        attrName:"灯具功率(W)",
                        valType:'input',
                    dictionary:'',
                    type:'Double'
                    },{
                        attrIndex:"lampsNumber",
                        attrName:"灯具数量",
                        valType:'input',
                    dictionary:'',
                    type:'Integer'
                    },{
                        attrIndex:"interactiveFlag",
                        attrName:"是否互动",
                        valType:'select',
                    dictionary:'shifouhudong',
                    type:'String'
                    },{
                        attrIndex:"interactiveType",
                        attrName:"互动类型",
                        valType:'select',
                    dictionary:'hudongleixing',
                    type:'String'
                    },{
                        attrIndex:"visualEffectEva",
                        attrName:"目视效果评价",
                        valType:'select',
                    dictionary:'mushixiaoguopingjia',
                    type:'String'
                    },{
                        attrIndex:"reasonDescription",
                        attrName:"原因说明",
                        valType:'checkbox',
                        dictionary:'yuanyinshuoming',
                        type:'String'
                    },
                ],
                // 原因说明
                yuanyinshuoming:'yuanyinshuoming'
            },
            2:{
                // 应用面信息
                yingyongmianxinxi:[
                {
                    attrIndex:"installationPosition",
                    attrName:"安装位置",
                    valType:'select',
                    dictionary:'anzhuangweizhi',
                    type:'String'
                },{
                    attrIndex:"viewingDistance",
                    attrName:"视看距离(KM)",
                    valType:'input',
                    dictionary:'',
                    type:'Double'
                },{
                    attrIndex:"viewingTime",
                    attrName:"观看时间",
                    valType:'select',
                    dictionary:'guankanshijian',
                    type:'String'
                }],
                // 照明目标
                zhaomingmubiao:[
                    {
                        attrIndex:"designBrightness",
                        attrName:"设计亮度(cd/m²)",
                        valType:'input',
                    dictionary:'',
                    type:'Double'
                    },{
                        attrIndex:"measuredBrightness",
                        attrName:"实测亮度(cd/m²)",
                        valType:'input',
                    dictionary:'',
                    type:'Double'
                    }
                ],
                // 设备信息
                shebeixinxi:[
                    {
                        attrIndex:"lampparamId",
                        attrName:"灯参编号",
                        valType:'input',
                    dictionary:'',
                    type:'String'
                    },{
                        attrIndex:"lampType",
                        attrName:"灯具类型",
                        valType:'select',
                    dictionary:'dengjuleixing',
                    type:'String'
                    },{
                        attrIndex:"lampPower",
                        attrName:"灯具功率(W)",
                        valType:'input',
                    dictionary:'Double',
                    type:''
                    },{
                        attrIndex:"pointSpacingH",
                        attrName:"横向点间距(mm)",
                        valType:'input',
                    dictionary:'',
                    type:'Double'
                    },{
                        attrIndex:"pointSpacingV",
                        attrName:"竖向点间距(mm)",
                        valType:'input',
                    dictionary:'',
                    type:'Double'
                    },{
                        attrIndex:"lampBand",
                        attrName:"灯具品牌",
                        valType:'input',
                    dictionary:'',
                    type:'String'
                    },{
                        attrIndex:"lampMode",
                        attrName:"灯具型号",
                        valType:'input',
                    dictionary:'',
                    type:'String'
                    },{
                        attrIndex:"visualEffectEva",
                        attrName:"目视效果评价",
                        valType:'select',
                    dictionary:'mushixiaoguopingjia',
                    type:'String'
                    },{
                        attrIndex:"reasonDescription",
                        attrName:"原因说明",
                        valType:'checkbox',
                    dictionary:'pingleiyuanyinshuoming',
                    type:'String'
                    },
                ],
                // 原因说明
                yuanyinshuoming:'pingleiyuanyinshuoming'
            },
            3:{
                // 应用面信息
                yingyongmianxinxi:[
                {
                    attrIndex:"carrierType",
                    attrName:"载体类型",
                    valType:'select',
                    dictionary:'tuanzaitileixing',
                    type:'String'
                },{
                    attrIndex:"illuminationH",
                    attrName:"被照面高度(m)",
                    valType:'input',
                    dictionary:'',
                    type:'Double'
                },{
                    attrIndex:"illuminationW",
                    attrName:"被照面宽度(m)",
                    valType:'input',
                    dictionary:'',
                    type:'Double'
                },{
                    attrIndex:"projectionDistance",
                    attrName:"投射距离(m)",
                    valType:'input',
                    dictionary:'',
                    type:'Double'
                }],
                // 照明目标
                zhaomingmubiao:[
                    {
                        attrIndex:"designBrightness",
                        attrName:"设计亮度(cd/m²)",
                        valType:'input',
                    dictionary:'',
                    type:'Double'
                    },{
                        attrIndex:"measuredBrightness",
                        attrName:"实测亮度(cd/m²)",
                        valType:'input',
                    dictionary:'',
                    type:'Double'
                    }
                ],
                // 设备信息
                shebeixinxi:[
                    {
                        attrIndex:"lampparamId",
                        attrName:"灯参编号",
                        valType:'input',
                    dictionary:'',
                    type:'String'
                    },{
                        attrIndex:"lampType",
                        attrName:"灯具类型",
                        valType:'select',
                        dictionary:'dengjuleixing',
                        type:'String'
                    },{
                        attrIndex:"lampPower",
                        attrName:"灯具功率(W)",
                        valType:'input',
                    dictionary:'',
                    type:'Double'
                    },{
                        attrIndex:"dynamicEffect",
                        attrName:"动态效果",
                        valType:'select',
                    dictionary:'tuandongtaixiaoguo',
                    type:'String'
                    },{
                        attrIndex:"lampBand",
                        attrName:"灯具品牌",
                        valType:'input',
                    dictionary:'',
                    type:'String'
                    },{
                        attrIndex:"lampMode",
                        attrName:"灯具型号",
                        valType:'input',
                    dictionary:'',
                    type:'String'
                    },{
                        attrIndex:"visualEffectEva",
                        attrName:"目视效果评价",
                        valType:'select',
                    dictionary:'mushixiaoguopingjia',
                    type:'String'
                    },{
                        attrIndex:"reasonDescription",
                        attrName:"原因说明",
                        valType:'checkbox',
                    dictionary:'tuanyuanyinshuoming',
                    type:'String'
                    },
                ],
                // 原因说明
                yuanyinshuoming:'tuanyuanyinshuoming'
            },
            4:{
                // 应用面信息
                yingyongmianxinxi:[
                {
                    attrIndex:"carrierType",
                    attrName:"载体类型",
                    valType:'select',
                    dictionary:'tuanzaitileixing',
                    type:'String'
                },{
                    attrIndex:"illuminationH",
                    attrName:"被照面高度(m)",
                    valType:'input',
                    dictionary:'',
                    type:'Double'
                },{
                    attrIndex:"illuminationW",
                    attrName:"被照面宽度(m)",
                    valType:'input',
                    dictionary:'',
                    type:'Double'
                },{
                    attrIndex:"projectionDistance",
                    attrName:"投射距离(m)",
                    valType:'input',
                    dictionary:'',
                    type:'Double'
                }],
                // 照明目标
                zhaomingmubiao:[
                    {
                        attrIndex:"designBrightness",
                        attrName:"设计亮度(cd/m²)",
                        valType:'input',
                        dictionary:'',
                        type:'Double'
                    },{
                        attrIndex:"measuredBrightness",
                        attrName:"实测亮度(cd/m²)",
                        valType:'input',
                    dictionary:'',
                    type:'Double'
                    }
                ],
                // 设备信息
                shebeixinxi:[
                    {
                        attrIndex:"lampparamId",
                        attrName:"灯参编号",
                        valType:'input',
                    dictionary:'',
                    type:'String'
                    },{
                        attrIndex:"lampType",
                        attrName:"灯具类型",
                        valType:'select',
                    dictionary:'dengjuleixing',
                    type:'String'
                    },{
                        attrIndex:"lampPower",
                        attrName:"灯具功率(W)",
                        valType:'input',
                    dictionary:'',
                    type:'Double'
                    },{
                        attrIndex:"waterTexture",
                        attrName:"水纹纹理",
                        valType:'select',
                    dictionary:'shuiwenwenli',
                    type:'String'
                    },{
                        attrIndex:"lampBand",
                        attrName:"灯具品牌",
                        valType:'input',
                    dictionary:'',
                    type:'String'
                    },{
                        attrIndex:"lampMode",
                        attrName:"灯具型号",
                        valType:'input',
                    dictionary:'',
                    type:'String'
                    },{
                        attrIndex:"visualEffectEva",
                        attrName:"目视效果评价",
                        valType:'select',
                    dictionary:'mushixiaoguopingjia',
                    type:'String'
                    },{
                        attrIndex:"reasonDescription",
                        attrName:"原因说明",
                        valType:'checkbox',
                        dictionary:'shuiwenyuanyinshuoming',
                        type:'String'
                    },
                ],
                // 原因说明
                yuanyinshuoming:'shuiwenyuanyinshuoming'
            },
        },
        // 字典列表
        dictionaryJson:{},
        // 原因说明
        reasonDescriptionArr:[],
        // 灯具品牌选择项
        lampBandArr:[],
        // 灯参编号选择项
        lampparamIdArr:[],
        // 原因说明后面的输入框是否展示
        otherFlag: false,
        request:{},//请求参数

        // 原因说明是否展示
        reasonFlag: true,

    }
  },
  created(){
    this.getReasonDescriptionArr()
    this.uploadUrl = this.$http.getSignUrl('/api/files/upload', {
        type: 'image'
    })
    // 加载灯具品牌
    this.getBrandData();
    // 加载等餐列表 获取灯参编号
    this.getItemListNo()
  },
  mounted(){
  },
  methods: { 
    // 点击灯参编号
    lookDetailInfo(item,index){
        this.$refs.realityQueryDetailPdf.show(item.split(',')[index])
    },
    // 原因说明点击事件
    checkboxChange(item){
        if(item.indexOf('E.其他') > -1){
            this.otherFlag = true
        }else{
            this.otherFlag = false
        }
    },
    // 修改视频数据
    changeVideoData(data){
        this.formData.videoLandingEffect = data;
    },
    // 修改图片数据
    changeImgData(attrIndex,data){
        this.formData[attrIndex] = data;
    },
    handleRemove(file) {
        console.log(file);
      },
      handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      },
      handleDownload(file) {
        console.log(file);
      },
    //   改变formData对应的值
    changeFormData(text,attrIndex){
        this.formData[attrIndex] = text
        //目视效果评价
        if(attrIndex=='visualEffectEva' && text=='效果较差'){
            this.reasonFlag =false;
        }else{
            this.reasonFlag =true;
        }
    },

    // 原因说明字典接口调用
    getReasonDescriptionArr(){
        this.$http.getSync('/api/dictTypeAllList', {
            indexPinyin: this.formItemData[this.headerType].yuanyinshuoming
        }, (res)=> {
            if (res.success) {
                this.reasonDescriptionArr = res.data
            }
        })
    },
    // 获取灯具品牌
    getBrandData(){
        //加载灯具品牌
        this.$http.postQuery('/api/banner/brands/stlampBrandJson',{},(res)=>{
            if(res.success){
                for(var i = 0;i<res.data.length;i++){
                    res.data[i].delFlag = '0'
                }
                this.lampBandArr = res.data;
            }
        })
    },
    // 加载项目列表 获取灯参编号
    getItemListNo(){
        var url = "/api/lampparams/pageJson/"+this.itemId


        this.request.contestType =this.formData.contestType
        this.$http.postObj(url,this.request,(res)=>{
            if(res.success){
                res.data.rows.forEach(e => {
                    this.lampparamIdArr.push(e.projectLampparamVo)
                });
            }
        })
    }
    
  },
  watch:{
  },
  components:{
    RealityQuerySelect,
    UploadImg,
    UpLoadVideo,
    RealityQueryDetailPdf
  }
};
</script>
<style lang="scss">
.formBox{
    border: 1px solid rgba(181, 181, 181, 0.4);
    header{
        height: 40px;
        background-color: #5a63a3;
        text-align: center;
        line-height: 40px;
        color: #fff;
        font-size: 16px;
        width: 100%;
        padding: 0;
    }
    .el-form{
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
    }
    .el-input{
        width: 160px!important;
        /* border: 1px solid #DCDFE6; */
        background-color: #FFF;
        height: 32px;
        line-height: 32px;
        border-radius: 4px;
    }
    .el-form-item{
        margin-bottom: 0;
        border-bottom: 1px solid rgba(181, 181, 181, 0.4);
    }
    .el-form-item__label{
        text-align: center;  
        height: 40px;  
    }
    .el-input__inner{
        border-radius: 4px;
        height: 32px;
        line-height: 32px;
    }
    .el-input.is-active .el-input__inner, .el-input__inner:focus{
        border-color: #DCDFE6;
    }
    .visualEffectEvaInputBox{
        .el-input{
            width: 560px;
        }
    }
    .el-form-item__content{
        height: 40px;    
        width: 190px;
        border-left: 1px solid #DCDFE6;
        border-right: 1px solid #DCDFE6;
        text-align: center;
    }
}
    .upLoadBox{
        width: 25%;
        .el-upload-list--picture-card .el-upload-list__item{
            width: 60px;
            height: 60px;
        }
        .el-upload--picture-card{
             width: 60px;
            height: 60px;
        }
        .el-upload--picture-card i{
            line-height: 60px;
            vertical-align: top;
        }
    }
    .bottomUpload{
            display: flex;
            flex-wrap: wrap;
    }
    .formBox .el-form-item__label{
        background-color: #f6f7fb;
    }
    .el-checkbox-group{
            white-space: nowrap;
    padding-left: 20px;
    }
    .checkoutBox{
            border-bottom: none!important;
        .el-form-item__content{
            width: 96%!important;
            // border-top: 1px solid #DCDFE6;
            border-right: none;
        }
       .el-input {
        margin-left: 20px;
       }
    }
    .el-button--primary {
    background-color: #5a63a3;
    border-radius: 4px;
    color: #fff;
    border: none;
}
.disabledClick{
    pointer-events:none;
}
.dengcanbianhaoBox{
    .el-select__tags{
        flex-wrap: nowrap;
        overflow-x: scroll;
    }
}
.opacity1{
    opacity: 1;
    height: auto;
}
.opacity0{
    input{
        height: 0;
    }
    opacity: 0;
}
 .dengcanbianhao{
    color: #238fcb;
    cursor: pointer;
    span{
        margin: 5px;
    }
    }
</style>